import { Action, createReducer, on } from '@ngrx/store';
import { RowDataDb, SectionData, SectionDataDb, SubSectionData, SubSectionDataDb } from 'src/app/model/help';
import * as HelpActions from './help.actions';

export interface State {
    helpList: SectionData[];
    helpSearchList: SubSectionData[];
    sections: SectionDataDb[];
    sectionCurrent: SectionDataDb;
    sectionModify: boolean;
    subsectionCurrent: SubSectionDataDb;
    subsections: SubSectionDataDb[];
    subsectionModify: boolean;
    rowCurrent: RowDataDb;
    rows: RowDataDb[];
    rowModify: boolean;
}

export const initialState: State = {
    helpList: [],
    helpSearchList: [],
    sections: [],
    sectionCurrent: undefined,
    sectionModify: false,
    subsectionCurrent: undefined,
    subsections: [],
    subsectionModify: false,
    rowCurrent: undefined,
    rows: [],
    rowModify: false,
};

const helpReducer = createReducer(
    initialState,
    on(HelpActions.getHelp, (state, payload) => ({
        ...state, helpList: []
    })),
    on(HelpActions.getHelpAll, (state, payload) => ({
        ...state, helpList: []
    })),
    on(HelpActions.getHelpSearch, (state, payload) => ({
        ...state, helpSearchList: []
    })),
    on(HelpActions.getHelpSuccess, (state, payload) => ({
        ...state, helpList: payload.sectionList
    })),
    on(HelpActions.getHelpAllSuccess, (state, payload) => ({
        ...state, helpList: payload.sectionList, sectionModify: false,
        rowModify: false, subsectionModify: false,
    })),
    on(HelpActions.getHelpGuestSuccess, (state, payload) => ({
        ...state, helpList: payload.sectionList
    })),
    on(HelpActions.getHelpGuestSearchSuccess, (state, payload) => ({
        ...state, helpSearchList: payload.subSectionList
    })),
    on(HelpActions.getHelpSearchSuccess, (state, payload) => ({
        ...state, helpSearchList: payload.subSectionList
    })),
    on(HelpActions.getHelpSectionAllSuccess, (state, payload) => ({...state,
        sections: payload.sectionList, sectionModify: false})),
    on(HelpActions.getHelpSectionSuccess, (state, payload) => ({...state,
        sectionCurrent: payload.section})),
    on(HelpActions.getHelpSectionsSuccess, (state, payload) => ({...state,
        sections: payload.sections})),
    on(HelpActions.addHelpSectionSuccess, (state) => ({
        ...state, sectionModify: true
    })),
    on(HelpActions.editHelpSectionSuccess, (state) => ({
        ...state, sectionModify: true
    })),
    on(HelpActions.deleteHelpSectionSuccess, (state) => ({
        ...state, sectionModify: true
    })),
    on(HelpActions.resetSectionForm, (state) => ({
        ...state, sectionCurrent: undefined, sectionModify: false,
    })),
    on(HelpActions.getHelpSubSectionsSuccess, (state, payload) => ({...state,
        subsections: payload.subsections})),
    on(HelpActions.getHelpSubSectionSuccess, (state, payload) => ({...state,
        subsectionCurrent: payload.subsection})),
    on(HelpActions.addHelpSubSectionSuccess, (state) => ({
        ...state, subsectionModify: true
    })),
    on(HelpActions.editHelpSubSectionSuccess, (state) => ({
        ...state, subsectionModify: true
    })),
    on(HelpActions.deleteHelpSubSectionSuccess, (state) => ({
        ...state, subsectionModify: true
    })),
    on(HelpActions.resetSubSectionForm, (state) => ({
        ...state, subsectionCurrent: undefined, subsectionModify: false,
    })),
    on(HelpActions.getHelpRowsSuccess, (state, payload) => ({...state,
        rows: payload.rows})),
    on(HelpActions.getHelpRowSuccess, (state, payload) => ({...state,
        rowCurrent: payload.row})),
    on(HelpActions.addHelpRowSuccess, (state) => ({
        ...state, rowModify: true
    })),
    on(HelpActions.editHelpRowSuccess, (state) => ({
        ...state, rowModify: true
    })),
    on(HelpActions.deleteHelpRowSuccess, (state) => ({
        ...state, rowModify: true
    })),
    on(HelpActions.resetRowForm, (state) => ({
        ...state, rowCurrent: undefined, rowModify: false,
    })),
);

export const reducer = (state: State | undefined, action: Action): State => helpReducer(state, action);
